import {
  GetAllNonWorkingHoursSuccess,
  GetAllNonWorkingHoursError,
  togglePageLoader,
  deleteNonWorkinghoursSuccess,
  deleteNonWorkinghoursError,
  insertupdateNonWorkinghoursSuccess,
  insertupdateNonWorkinghoursError,
} from "store/actions"
import { call, put, takeEvery } from "redux-saga/effects"
import toast from "toastr"
// Login Redux States
import {
  get_allnonworkinghours,
  post_allnonworkinghours,
  del_allnonworkinghours,
} from "helpers/backend_helper"

import {
  GET_ALL_NON_WORKING_HOURS,
  INSERT_UPDATE_NON_WORKING_HOURS,
  DELETE_NON_WORKING_HOURS,
} from "./actionType"

function* getNonWorkingHoursList({ payload: data }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(get_allnonworkinghours, data)
    if (response.status === "Success") {
      yield put(GetAllNonWorkingHoursSuccess(response))
      yield put(togglePageLoader(false))
    } else {
      yield put(GetAllNonWorkingHoursError(response))
      yield put(togglePageLoader(false))
    }
  } catch (error) {
    yield put(GetAllNonWorkingHoursError(error))
    yield put(togglePageLoader(false))
  }
}

function* updateInsertNonWorkingHoursList({ payload: data, callback }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(post_allnonworkinghours, data)
    if (response.status === "Success") {
      yield put(insertupdateNonWorkinghoursSuccess(response))
      toast.success(response.message)
      callback("SUCCESS")
      yield put(togglePageLoader(false))
    } else {
      yield put(insertupdateNonWorkinghoursError(response))
      toast.error(response?.message)
      callback("ERROR")
      yield put(togglePageLoader(false))
    }
  } catch (error) {
    yield put(insertupdateNonWorkinghoursError(error))
    // toast.error(error?.response ? error.response?.data?.message : error)
    yield put(togglePageLoader(false))
  }
}

function* deleteNonWorkingHoursList({ payload: id }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(del_allnonworkinghours, id)
    if (response.statusCode === 200) {
      yield put(deleteNonWorkinghoursSuccess(response))
      toast.success(response.message)
      yield put(togglePageLoader(false))
    } else {
      yield put(deleteNonWorkinghoursError(response))
      toast.error(response.message)
      yield put(togglePageLoader(false))
    }
  } catch (error) {
    yield put(deleteNonWorkinghoursError(error))
    toast.error(error?.response ? error.response?.data?.message : error)
    yield put(togglePageLoader(false))
  }
}

function* calculateincentivesage() {
  yield takeEvery(GET_ALL_NON_WORKING_HOURS, getNonWorkingHoursList)
  yield takeEvery(DELETE_NON_WORKING_HOURS, deleteNonWorkingHoursList)
  yield takeEvery(
    INSERT_UPDATE_NON_WORKING_HOURS,
    updateInsertNonWorkingHoursList
  )
}

export default calculateincentivesage
